import { environmentService, userService, postRequestHandler, getRequestHandler } from "@/utils/services";
import { compress, decompress } from 'lz-string';

let apiUrl = environmentService.apiUrlRatePlan;
let apiUrlRT = environmentService.apiUrlHotel;
let headers = { headers: userService.authHeader() };

export const rateService = {
  searchRate,
  createRate,
  EditRate,
  showRoomstype,
  currency
};
async function currency() {
  var currencies = null;
  if (localStorage.getItem(`global:currencies`)) {
    currencies = JSON.parse(decompress(localStorage.getItem(`global:currencies`)));
  }
  if (currencies && currencies.length > 0) {
    return await currencies;
  } else {
    return await getRequestHandler(`${apiUrl}/currencies`, headers);
  }
}
async function searchRate(rateSearch) {
  return await postRequestHandler(`${apiUrl}/rates`, rateSearch, headers);
}
async function showRoomstype(hotelIds) {
  return await postRequestHandler(`${apiUrlRT}/hotels/roomtypes`, hotelIds, headers);
}

async function createRate(NewRate) {
  return await postRequestHandler(`${apiUrl}/rates/create`, NewRate, headers);
}

async function EditRate(EditRate) {
  return await postRequestHandler(`${apiUrl}/rates/update`, EditRate, headers);
}



// WEBPACK FOOTER //
// ./src/utils/services/rate/rate.service.js